<mat-selection-list
  role="list"
  [multiple]="false"
  class="u-list-box"
  [hideSingleSelectionIndicator]="true"
  (selectionChange)="onChangeEvent()"
  [(ngModel)]="selectedItems"
>
  @if (group()) {
    @for (groupItem of items(); track groupItem[groupTrack() || labelField()]; let groupIndex = $index) {
      @if (groupTemplate()) {
        <ng-container *ngTemplateOutlet="groupTemplate(); context: { $implicit: groupItem, index: groupIndex }"></ng-container>
      } @else {
        <div class="group-item">
          <span>{{ group[labelField()] }}</span>
        </div>
      }
      @for (item of groupItem['items']; track itemTrack() ? item[itemTrack()] : item; let itemIndex = $index) {
        <mat-list-option [value]="item" (focus)="onFocus(item)">
          <ng-container *ngIf="itemTemplate(); else defaultItem">
            <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item, index: itemIndex }"></ng-container>
          </ng-container>
          <ng-template #defaultItem>
            <div class="list-item">
              <span>{{ item[labelField()] }}</span>
            </div>
          </ng-template>
        </mat-list-option>
      }
    }
  } @else {
    @for (item of items(); track itemTrack() ? item[itemTrack()] : item; let itemIndex = $index) {
      <mat-list-option [value]="item" (focus)="onFocus(item)">
        <ng-container *ngIf="itemTemplate(); else defaultItem">
          <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item, index: itemIndex }"></ng-container>
        </ng-container>
        <ng-template #defaultItem>
          <div class="list-item">
            <span>{{ item[labelField()] }}</span>
          </div>
        </ng-template>
      </mat-list-option>
    }
  }
</mat-selection-list>
